/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Invalid_CredentialsInputs */

const en_login_error_invalid_credentials = /** @type {(inputs: Login_Error_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email or password is incorrect.`)
};

const ar_login_error_invalid_credentials = /** @type {(inputs: Login_Error_Invalid_CredentialsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البريد الإلكتروني أو كلمة المرور غير صحيحة.`)
};

/**
* | output |
* | --- |
* | "Email or password is incorrect." |
*
* @param {Login_Error_Invalid_CredentialsInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_error_invalid_credentials = /** @type {((inputs?: Login_Error_Invalid_CredentialsInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Invalid_CredentialsInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_error_invalid_credentials(inputs)
	return ar_login_error_invalid_credentials(inputs)
});